import { Grid } from '@mui/material';
import React from 'react';
import { useEffectiveRoleViewAuthorizationServiceContext } from '../../../../context/contexts';
import { MetricQueryTooltip } from '../../modals/MetricQueryModal';
import { KpiQueryMetaData } from './types';

interface ComponentWithMetaProps<BaseComponentProps extends object> {
  meta: KpiQueryMetaData[];
  componentProps: BaseComponentProps;
  children: (props: BaseComponentProps) => React.ReactNode;
}

export const ComponentWithMeta = <BaseComponentProps extends object>(
  props: ComponentWithMetaProps<BaseComponentProps>
) => {
  const { meta, componentProps, children } = props;
  const metrics = meta.map((m) => m.metric);
  const metricsSql = meta.map((m) => m.metricsSql);
  const authorizationService =
    useEffectiveRoleViewAuthorizationServiceContext();
  const canSeeChartDevOptions = authorizationService.canSeeChartDevOptions();
  return (
    <Grid item container sx={{ position: 'relative', height: '100%' }}>
      {canSeeChartDevOptions ? (
        <Grid item sx={{ position: 'absolute', top: 0, right: 0, padding: 1 }}>
          <MetricQueryTooltip metrics={metrics} metricsSql={metricsSql} />
        </Grid>
      ) : null}
      {children(componentProps)}
    </Grid>
  );
};
